import { useCallback } from "react";
import { useHideInformationUpdateBannerMutation } from "src/graphql-next/generated/queries";
import { BrandCodeEnum } from "src/graphql/generated/types";
import { useBrandStore } from "src/stores/brand-store";

import {
  useCurrentCustomer,
  useInvalidateCurrentCustomer,
} from "./use-current-customer";

export function useIsInformationUpdateBannerShown(): boolean {
  const { shouldShowInformationUpdateBanner } = useCurrentCustomer();
  const isFoncia = useBrandStore(
    (state) => state.brandCode === BrandCodeEnum.Foncia,
  );

  return isFoncia && shouldShowInformationUpdateBanner;
}

export function useHideInformationUpdateBanner(): () => void {
  const isShown = useIsInformationUpdateBannerShown();
  const { id: customerId } = useCurrentCustomer();
  const invalidateCurrentCustomer = useInvalidateCurrentCustomer();
  const { mutate: hideInformationUpdateBanner } =
    useHideInformationUpdateBannerMutation({
      onSuccess: ({ hideInformationUpdateBanner: result }) => {
        if (result.__typename === "CustomerNotFoundException") {
          return;
        }

        return invalidateCurrentCustomer();
      },
    });

  return useCallback(() => {
    if (isShown) {
      hideInformationUpdateBanner({ customerId });
    }
  }, [isShown, hideInformationUpdateBanner, customerId]);
}
